module.exports = __webpack_public_path__ + "img/teeth-31.5a429a82.png";